import { render, staticRenderFns } from "./add-face.vue?vue&type=template&id=37f66cd5&scoped=true&"
import script from "./add-face.vue?vue&type=script&lang=js&"
export * from "./add-face.vue?vue&type=script&lang=js&"
import style0 from "./add-face.vue?vue&type=style&index=0&id=37f66cd5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f66cd5",
  null
  
)

export default component.exports